import React from "react";
import { Button } from "reactstrap";
import { useDragContext } from "react-admin-base";
export default function DragAndDropArrow(props) {
    const [ref, isDragging] = useDragContext();
    if (!ref)
        return null;
    return React.createElement(Button, Object.assign({ type: "button", innerRef: ref, outline: true, size: "sm", color: "primary" }, props),
        React.createElement("i", { className: "fas fa-" + (isDragging ? "circle-dot" : "arrows-up-down-left-right") }),
        props.children);
}
